// external imports
import React from 'react'
import { FlexRow, FlexColumn } from 'quark-web'
// local imports
import { Text } from '~/components'
import styles from './styles'

// the API_KEY to access google
const key = process.env.GOOGLE_API_KEY

const Location = ({ name, street, city, telephone, fax, email, showMap }) => {
    // the address pointe
    // the url that shows the map using google
    const url = encodeURI(
        `https://maps.googleapis.com/maps/api/staticmap?center=${street} ${city}&size=119x80&maptype=roadmap&key=${key}`
    )

    return (
        <FlexRow style={styles.container}>
            {showMap && <img src={url} width={119} height={80} style={styles.map} />}
            <FlexColumn>
                <Text style={styles.title}>{name}</Text>
                <Text style={styles.text}>{street}</Text>
                <Text style={styles.text}>{city}</Text>
                <Text style={styles.text}>
                    Tel. {telephone} • Fax. {fax}
                </Text>
            </FlexColumn>
        </FlexRow>
    )
}

Location.defaultProps = {
    showMap: true
}

export const LocationBilling = props => (
    <Location
        name="billing"
        street="115 W California Bl, Suite 197"
        city="Pasadena, CA 91105 U.S.A."
        telephone="(626) 396-9018"
        fax="(626) 396-9087"
        email="info@larkseeds.com"
        {...props}
    />
)
export const LocationResearch = props => (
    <Location
        name="research"
        street="39582 Co Road 25A"
        city=" Woodland CA 95695"
        telephone="(626) 396-9018"
        fax="(626) 396-9087"
        email="info@larkseeds.com"
        {...props}
    />
)
export const LocationDistributors = props => (
    <Location
        name="distribution center"
        street="281 N Pioneer Ave"
        city="Woodland, CA 95776"
        telephone="(626) 396-9018"
        fax="(626) 396-9087"
        email="info@larkseeds.com"
        {...props}
    />
)



// WEBPACK FOOTER //
// ./src/components/Location/index.js